import React from 'react';
import { bool, func, number, object, oneOfType, string } from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import { Chip, CodeBlock, Spinner, TabPanel } from '../../../../../../../../components';
import Response from '../Response';

import { staticText } from '../../TestWebhookModal';

const TestPanel = ({
  index,
  currentTab,
  callbackUri,
  testPayload,
  tested,
  response,
  isTestingWebhook,
  testWebhook,
  toggleModal,
  type,
}) => {
  return (
    <TabPanel value={currentTab} index={index}>
      <Box display="flex" gap={2} alignItems="center" marginBottom={2}>
        <Chip label={staticText.chip} type="post" />
        <Typography variant="body2">{callbackUri}</Typography>
      </Box>
      <CodeBlock code={JSON.stringify(testPayload, null, 2)} styles={{ maxHeight: '300px' }} />
      {tested && (
        <Response
          isFetching={isTestingWebhook}
          response={response}
          testWebhook={testWebhook}
          toggleModal={toggleModal}
          type={type}
        />
      )}
      {!tested && (
        <Box display="flex" justifyContent="flex-end" marginTop={2}>
          <Button
            variant="outlined"
            disabled={isTestingWebhook}
            onClick={() => testWebhook(type)}
            startIcon={isTestingWebhook && <Spinner size="button" />}
          >
            {type === 'error' ? staticText.buttons.errorTest : staticText.buttons.dataTest}
          </Button>
        </Box>
      )}
    </TabPanel>
  );
};

export default TestPanel;

TestPanel.propTypes = {
  index: number.isRequired,
  currentTab: number.isRequired,
  callbackUri: string.isRequired,
  testPayload: oneOfType([object, string]).isRequired,
  tested: bool.isRequired,
  response: oneOfType([object, string]),
  isTestingWebhook: bool.isRequired,
  testWebhook: func.isRequired,
  toggleModal: func.isRequired,
  type: string,
};

TestPanel.defaultProps = {
  response: {},
  type: 'data',
};
